var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"edit-voucher","header-class":"splash-header-modal ten-padding","footer-class":"splash-footer-modal space-evenly","size":"xl"}})}
var staticRenderFns = []

export { render, staticRenderFns }